export const throttle = () => {
    let isThrottled = false;

    return (func, delay, throttling = true) => {
        if (!throttling) {
            func();
            return;
        }

        if (isThrottled) {
            return;
        }

        isThrottled = true;
        setTimeout(() => {
            func();
            isThrottled = false;
        }, delay);
    };
}